import React from 'react';
import {ScrollView, Text} from 'react-native';
import {storiesOf} from '@storybook/react-native';
import {noop} from 'lodash';

import {
  Code,
  FlexView,
  Heading,
  Spacer,
  Spacing,
} from '/component/base/Storybook';

import ProfileAttribute from '../ProfileAttribute';

storiesOf('base', module).add('ProfileAttribute', () => (
  <ScrollView>
    <Spacing size={20}>
      <FlexView>
        <Heading level={1}>Profile Attribute</Heading>
        <Spacer size={16} />
        <Text>
          The <Code>ProfileAttribute</Code> component is used to render an
          individual attribute in user's profile.
        </Text>
        <Spacer size={16} />
        <ProfileAttribute label="Full Name" value="Kathryn Janeway" />
        <Spacer size={6} />
        <Code>{'<ProfileAttribute'}</Code>
        <Code>{'  label="Full Name"'}</Code>
        <Code>{'  value="Kathryn Janeway"'}</Code>
        <Code>{'/>'}</Code>
        <Spacer size={16} />
        <Text>
          To control which icon appears, set the The <Code>iconName</Code> prop:
        </Text>
        <Spacer size={16} />
        <ProfileAttribute
          iconName="certified"
          label="Rank (NEM)"
          value="Vice Admiral‎"
          isArrow
        />
        <Spacer size={6} />
        <Code>{'<ProfileAttribute'}</Code>
        <Code>{'  iconName="certified"'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'/>'}</Code>
        <Spacer size={16} />
        <Text>
          If the value of the <Code>onPress</Code> prop is a function, the
          entire component will become touchable and the text of the value will
          be rendered in a different color:
        </Text>
        <Spacer size={16} />
        <ProfileAttribute
          iconName="profile"
          label="Portrayed by"
          value="Kate Mulgrew"
          onPress={noop}
          isArrow
        />
        <Spacer size={6} />
        <Code>{'<ProfileAttribute'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'  onPress={() => ...}'}</Code>
        <Code>{'isArrow'}</Code>
        <Code>{'/>'}</Code>
        <Spacer size={16} />
        <Text>
          To control the unique style for Details section in the User Profile
          pass <Code>isDetails</Code> prop:
        </Text>
        <Spacer size={16} />
        <ProfileAttribute
          iconName="profile"
          label="Portrayed by"
          value="Kate Mulgrew"
          onPress={noop}
          isDetails
        />
        <Spacer size={6} />
        <Code>{'<ProfileAttribute'}</Code>
        <Code>{'  ...'}</Code>
        <Code>{'  onPress={() => ...}'}</Code>
        <Code>{'isDetails'}</Code>
        <Code>{'/>'}</Code>
      </FlexView>
    </Spacing>
  </ScrollView>
));
